<app-nav></app-nav>
<section class="login-section">
  <div class="container">
    <div class="product-container">
      <div class="product-inner top-gap-md">
        <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" >
          <div class="form-group">
            <select class="form-control" name="relation" id="relation">
              <option disabled selected>Relation</option>
              <option>Father</option>
              <option>Mother</option>
              <option>Husband</option>
              <option>Wife</option>
              <option>Son</option>
              <option>Daughter</option>
            </select>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" name="name" id="name" placeholder="Name">
          </div>
          
          <div class="form-group">
            <input type="text" class="form-control" name="dob" id="dob" placeholder="Date of Birth">
          </div>
          
          <div class="row top-gap-lg">
              <div class="col">
                <button class="btn btn-submit btn-primary" type="submit" routerLink="/otp">Submit</button>
              </div>
          </div>
          
        </form>
      </div>
    </div>
  </div>
</section>